import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * Button to seek forward/back
 *
 * @extends Button
 * @class SeekButton
 */
class SeekButton extends Button {
  /**
   * Constructor for class
   *
   * @param {Player|Object} player The player
   * @param {Object=} options Button options
   * @param {string} options.direction back or forward
   * @param {Int} options.seconds number of seconds to seek
   */
  constructor(player, options) {
    super(player, options);

    if (this.options_.direction === 'forward') {
      this.controlText(
        this.localize('Seek forward {{seconds}} seconds').replace(
          '{{seconds}}',
          this.options_.seconds
        )
      );
    } else if (this.options_.direction === 'back') {
      this.controlText(
        this.localize('Seek back {{seconds}} seconds').replace(
          '{{seconds}}',
          this.options_.seconds
        )
      );
    }
  }

  /**
   * Return button class names which include the seek amount.
   *
   * @return {string} css cass string
   */
  buildCSSClass() {
    /* Each button will have the classes:
       `vjs-seek-button`
       `skip-forward` or `skip-back`
    */
    return `vjs-seek-button skip-${
      this.options_.direction
    } ${super.buildCSSClass()}`;
  }

  /**
   * Seek with the button's configured offset
   */
  handleClick() {
    const now = this.player_.currentTime();

    if (this.options_.direction === 'forward') {
      this.player_.trigger('gvseeked');
      this.player_.currentTime(now + this.options_.seconds);
    } else if (this.options_.direction === 'back') {
      this.player_.trigger('gvseeked');
      this.player_.currentTime(now - this.options_.seconds);
    }
  }
}

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function setSeekButtons
 * @param    {Player} player
 *           A Video.js player object.
 *
 */
const setSeekButtons = player => {
  player.controlBar.seekBack = player.controlBar.addChild(
    'seekButton',
    {
      direction: 'back',
      seconds: 5
    },
    0
  );

  player.controlBar.seekForward = player.controlBar.addChild(
    'seekButton',
    {
      direction: 'forward',
      seconds: 5
    },
    2
  );
};

videojs.registerComponent('SeekButton', SeekButton);

export default setSeekButtons;
